import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { BACKEND_URL } from "@/lib/api";

export default function Shortcode() {
  const { code } = useParams();
  useEffect(() => {
    // Hand off to backend which redirects to the actual survey with signed tokens
    window.location.replace(`${BACKEND_URL}/api/s/${code}`);
  }, [code]);
  return (
    <div className="min-h-screen bg-[#050505] text-white flex items-center justify-center" data-testid="shortcode-bridge">
      <div className="glass rounded-2xl p-8 max-w-md text-center">
        <div className="text-xs uppercase tracking-widest text-mute mb-2">SyncLine</div>
        <h1 className="font-display font-extrabold text-2xl mb-2">Preparing your survey…</h1>
        <p className="text-mute text-sm">You are being redirected securely.</p>
      </div>
    </div>
  );
}
